import { IPricingSection } from '../interfaces/IPricingPageTableData';

const PRICING_TABLE_DATA: IPricingSection[] = [
  {
    sectionName: 'Foundations',
    features: [
      {
        feature: 'Property discounts',
        tooltip:
          'Unlock Premium features by contacting us t receive customized per property discounts based on your volume',
        values: [
          'None',
          '$10 off all jobs',
          '$10+ off all jobs',
          '$10+ off all jobs',
        ],
      },
      {
        feature: 'Property storage',
        tooltip:
          'Store all your properties, measurements, and models in our secure cloud infrastrcuture',
        values: ['12 months', 'Unlimited', 'Unlimited', 'Unlimited'],
      },
      {
        feature: 'Measurement PDF',
        tooltip:
          'Industry-leading accuracy is presented in a familiar PDF deliverable',
        values: [true, true, true, true],
      },
      {
        feature: 'Interactive 3D Model',
        tooltip: 'View real products from real manufacturers on the 3D model',
        values: [true, true, true, true],
      },
      {
        feature: 'Multi-platform Access',
        tooltip:
          'Access your measurements, 3D models, photos and notes from our iOS, Android, and web apps.',
        values: [true, true, true, true],
      },
      {
        feature: 'Design in 3D',
        tooltip:
          'Use our simple, powerful design software to try real manufacturer products on a 3D model of your actual home.',
        values: [true, true, true, true],
      },
      {
        feature: 'Capture only',
        tooltip:
          'Capture and store unlimited property photos at no cost, and order the measurements and 3D model when you are ready',
        values: [true, true, true, true],
      },
      {
        feature: 'API access',
        tooltip:
          'Programmatic access to our ecosystem to build robust integrations with other software systems in order to streamline workflows and save time',
        values: [true, true, true, true],
      },
      {
        feature: 'Data exports',
        tooltip:
          'Export measurement and 3D model data from HOVER in file formats usable by other software in your existing workflow',
        values: [
          'PDF, XLS',
          'PDF, XLS, XML, JSON',
          'PDF, XLS, XML, JSON, SKP, DWG, DXF, ESX',
          'PDF, XLS, XML, JSON, SKP, DWG, DXF, ESX',
        ],
      },
      {
        feature: 'Expedited job processing',
        tooltip:
          'Jump higher in the queue to get time-sensitive jobs returned more quickly (additional fee)',
        values: ['+$40', '+$30', '+$20', '+$20'],
      },
      {
        feature: 'Photo capture',
        tooltip:
          'Use your smartphone to take ground-level photos of a property which will be turned into measurements and a 3D model',
        values: [true, true, true, true],
      },
      {
        feature: 'Direct ordering',
        tooltip:
          'Order electronically form leading suppliers with zero manual entry and without leaving the console',
        values: [true, true, true, true],
      },
    ],
  },
  {
    sectionName: 'Workflow Enhancement',
    features: [
      {
        feature: 'Invite others to capture',
        tooltip:
          'Invite anyone to photograph a property for you using HOVER Connect, for which you will receive full measurements and a 3D model',
        values: [false, true, true, true],
      },
      {
        feature: 'Personalized branding',
        tooltip: 'Add your logo to all measurement PDFs',
        values: [false, true, true, true],
      },
      {
        feature: 'Gallery and screenshot mode',
        tooltip:
          'Add real products from real manufacturers to 3D models of any property, create multiple versions, and showcase these options to clients',
        values: [false, true, true, true],
      },
      {
        feature: 'Integrations (contractors)',
        tooltip:
          'Eliminate manual data entry by integrating HOVER into your existing CRM, Job management, and financing software - JobNimbus, JobProgress, Leap to Digital, CompanyCam, Zapier, i360, Restoration AI, SalesRabbit, Hatch, GAF Project, Mosaic',
        values: [false, true, true, true],
      },
      {
        feature: 'Integrations (Insurance)',
        tooltip:
          'Eliminate manual data entry by integrating HOVER into your existing claims management and estimation software - CoreLogic (Symbility), OnSeen, Accurence, FileTrac, ClaimAssist, VCA',
        values: [false, true, true, true],
      },
    ],
  },
  {
    sectionName: 'Enterprise Features',
    features: [
      {
        feature: 'Priority Support',
        tooltip: 'Jump to the front of the line with priority support queues',
        values: [false, false, true, true],
      },
      {
        feature: 'Priority Job Processing',
        tooltip:
          'Unlock quicker average delivery without paying for expedited job processing',
        values: [false, false, true, true],
      },
      {
        feature: 'Assigned Account Manager',
        tooltip:
          'Talk to an assigned Account Manager for questions about the product or your business',
        values: [false, false, true, true],
      },
      {
        feature: 'Single Sign-on (SSO)',
        tooltip:
          'Enable enterprise-grade security and authentication for your entire team',
        values: [false, false, true, true],
      },
      {
        feature: 'Advanced Admin and User Permissions',
        tooltip:
          'Control access to certain features for third parties and internal team members',
        values: [false, false, true, true],
      },
    ],
  },
  {
    sectionName: 'End-to-end Estimation and Ordering',
    features: [
      {
        feature: 'Estimation',
        tooltip:
          'Accurate estimates for multiple trades in seconds that reflect job complexity and your unique pricing',
        values: [false, false, false, true],
      },
      {
        feature: 'Proposals and Contracts',
        tooltip:
          'Automatically populate your contract templates and get digital signatures while onsite',
        values: [false, false, false, true],
      },
      {
        feature: 'Production Console',
        tooltip:
          'Demystify and speed up project management with all the dependable resources you need to produce a job; from detailed takeoffs to measurements and job economic',
        values: [false, false, false, true],
      },
      {
        feature: 'Materials Management',
        tooltip: 'Precise, pre-populated, material lists for multiple trades',
        values: [false, false, false, true],
      },
      {
        feature: 'Labor Management',
        tooltip:
          'Generate work orders in a click that reflect a project’s specific installation needs',
        values: [false, false, false, true],
      },
      {
        feature: 'Onboarding',
        tooltip:
          'White glove service to customize HOVER features to reflect your pricing and process in weeks, not months',
        values: [false, false, false, true],
      },
    ],
  },
];

export default PRICING_TABLE_DATA;
